import { RESIDENT_ONLY_ACCOUNT_COUNTRIES, RESIDENT_ONLY_ACCOUNT_EDIT_TYPES } from '../../../constants';

export function applyDataControlRules(formData, fieldName, fieldValue, fieldPrefix, editType) {
  // if (fieldName === "surAvailable" && fieldValue === false) {
  //   formData["sur"] = false;
  // }

  if (fieldName === "subAccountLendingLimit" && fieldValue && fieldValue.toLowerCase() === "n/a") {
    formData["lendingLimitBreachAction"] = undefined;
  }

  if (fieldName === "subAccountLendingLimit" && fieldValue === '') {
    formData['lendingLimitBreachAction'] = {
      name: "N/A",
      value: "na"
    }
  }

  if (fieldName === "subAcountBorrowingLimit" && fieldValue && fieldValue.toLowerCase() === "n/a") {
    formData["borrowingLimitBreachAction"] = undefined;
  }

  if (fieldName === "subAcountBorrowingLimit" && fieldValue === '') {
    formData['borrowingLimitBreachAction'] = {
      name: "N/A",
      value: "na"
    }
  }

  if (fieldName === "glsProductType" && fieldValue && fieldValue.value === "interest") {
    formData["marginApplicable"] = false;
  }

  /* if (fieldName === "glcmImplementation" && !fieldValue) {
    formData["projectNo"] = '';
  } */

  // Clearing out the value in the other input field of the radiogroup based on if CS/CMP radio button is selected
  // This prevents unwanted values while sending payload and removes validation state for the unrequired radio button value
  if (fieldName === "projectNo") {
    if (fieldValue === 'CS') {
      formData['cmpProjectID'] = '';
    } else if (fieldValue === 'CMP') {
      formData['csProjectNumber'] = '';
    }
  }

  // DGT-10418: UAE and Qatar accounts can only be resident accounts
  // Default residency to resident as soon as one of those countries is selected.
  if (fieldName === "country" &&
    RESIDENT_ONLY_ACCOUNT_EDIT_TYPES.includes(editType) &&
    fieldValue &&
    RESIDENT_ONLY_ACCOUNT_COUNTRIES.has(fieldValue.value)) {
    formData["residency"] = true;
  }

  return formData;
}



// WEBPACK FOOTER //
// ./src/components/common/Dynamicform/dataControlRules.js